module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1 myp",
    attrs: {
      "id": "شكر-وتقدير"
    }
  }, [_c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تنويه:")])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كلُّ أحداث هذه الرواية هي مِن وحي خيال الكاتبة، ولا تمتُّ للحقيقة بِصِلة.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('span', {
    staticStyle: {
      "text-decoration": "underline !important"
    }
  }, [_vm._v("الحديث ذو الخط في الأسفل هو حديث داخلي")]), _vm._v("، "), _c('strong', [_vm._v("والحديث البارز هو الحديث المسموع.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdc24252","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0002.vue
// module id = 75
// module chunks = 0